"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@material-ui/core/styles");
var _typography = _interopRequireDefault(require("./typography"));
var _palette = require("./palette");
var _defaultProps = _interopRequireDefault(require("./defaultProps"));
var _staticComponentSizes = _interopRequireDefault(require("./staticComponentSizes"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * This file allows Material UI to inject the overall theme for this project
 * via the <ThemeProvider /> context.
 *
 * Here we are overriding the default Google Material Design Theme config and providing
 * our own variables which match the Elevator Design System.
 * For more information on how this functions:
 *
 * https://material-ui.com/customization/themes/
 */
var theme = (0, _styles.createTheme)(_objectSpread(_objectSpread(_objectSpread({}, _typography.default), _defaultProps.default), {}, {
  static_component_sizes: _staticComponentSizes.default,
  palette: _palette.palette
}));
var _default = exports.default = (0, _styles.responsiveFontSizes)(theme);